module.exports = __webpack_public_path__ + "static/verifyImage-496c480a70f366123ceaa3f0e9616732.png";